import { api } from "../app/endpoints";
import { language } from "./helpers/service-helper";

export const fetchPortfolio = () =>
  fetch(api.portfolio)
    .then((res) => res.json())
    .then((data) => data.items)
    .then(language);
